export default __webpack_public_path__ + "static/aktualnosci-hero-df6b19b486897c37e71669241d736f9c.jpg";